import { styled } from '../../../config'

const Root = styled('div', {
  position: 'relative',
  width: 'inherit'
})

export const NumberInputPrimitive = {
  Root
}
